import { useEffect } from "react";
import { Reveal, Overline } from "@/components/Reveal";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-display text-2xl font-bold tracking-tight mb-3">{title}</h2>
    <div className="text-white/60 text-sm sm:text-base leading-relaxed space-y-4">{children}</div>
  </div>
);

export function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy — Wired 2 Win Golf";
  }, []);

  return (
    <main data-testid="privacy-page" className="pt-32 lg:pt-40">
      <div className="max-w-3xl mx-auto px-6 pb-28">
        <Overline className="mb-6">Legal</Overline>
        <Reveal>
          <h1 className="font-display font-black tracking-tighter text-5xl sm:text-6xl uppercase mb-4">Privacy Policy</h1>
          <p className="text-white/40 text-sm mb-14">Last updated: July 2026</p>
        </Reveal>
        <Reveal>
          <Section title="What we collect">
            <p>When you take the Wired2Win assessment, subscribe, or contact us, we collect your email address, optionally your first name, your assessment responses and results, and any message you send us.</p>
            <p>We also collect anonymous usage events (such as page views and button clicks) to understand how the site is used and improve the experience.</p>
          </Section>
          <Section title="How we use it">
            <p>Your email is used to deliver your assessment results and, if you subscribe, our weekly mindset drills. Contact form details are used solely to respond to your inquiry.</p>
            <p>We do not sell, rent, or share your personal information with third parties for their marketing purposes.</p>
          </Section>
          <Section title="Your choices">
            <p>You can unsubscribe from emails at any time using the link in any email we send. To request deletion of your data, contact us at dbisbee@egolfgroup.com.</p>
          </Section>
          <Section title="Data storage">
            <p>Your data is stored securely in our database and retained only as long as needed to provide the service. We use industry-standard measures to protect it.</p>
          </Section>
          <Section title="Changes">
            <p>We may update this policy from time to time. Material changes will be announced on this page with an updated date.</p>
          </Section>
        </Reveal>
      </div>
    </main>
  );
}

export function Terms() {
  useEffect(() => {
    document.title = "Terms of Service — Wired 2 Win Golf";
  }, []);

  return (
    <main data-testid="terms-page" className="pt-32 lg:pt-40">
      <div className="max-w-3xl mx-auto px-6 pb-28">
        <Overline className="mb-6">Legal</Overline>
        <Reveal>
          <h1 className="font-display font-black tracking-tighter text-5xl sm:text-6xl uppercase mb-4">Terms of Service</h1>
          <p className="text-white/40 text-sm mb-14">Last updated: July 2026</p>
        </Reveal>
        <Reveal>
          <Section title="The service">
            <p>Wired 2 Win Golf provides a mental-game assessment, educational content, and an email newsletter for golfers. The service is provided "as is" for informational and educational purposes.</p>
          </Section>
          <Section title="Not professional advice">
            <p>Our content is not medical, psychological, or professional coaching advice. Assessment results are educational indicators, not clinical evaluations.</p>
          </Section>
          <Section title="Acceptable use">
            <p>You agree not to misuse the site, attempt to access administrative areas without authorization, or scrape content at scale. We may suspend access for abuse.</p>
          </Section>
          <Section title="Intellectual property">
            <p>All content, branding, and assessment materials are the property of Wired 2 Win Golf. You may share links freely; you may not republish content without permission.</p>
          </Section>
          <Section title="Liability">
            <p>To the maximum extent permitted by law, Wired 2 Win Golf is not liable for any indirect or consequential damages arising from use of the site. Golf scores remain your own responsibility.</p>
          </Section>
          <Section title="Contact">
            <p>Questions about these terms: dbisbee@egolfgroup.com.</p>
          </Section>
        </Reveal>
      </div>
    </main>
  );
}
